import { TabPanel, TabView } from "primereact/tabview";
import { SkillLevels } from "../SkillLevels/SkillLevelsPage";
import { RideTypesPage } from "../RideTypes/RideTypesPage";
import { SizeTypesPage } from "../SizeTypes/SizeTypesPage";
import { useMemo } from "react";
import { authService } from "../../services/auth.service";
import { TreatmentTypesPage } from "../TreatmentTypes/TreatmentTypesPage";
import { HorseGroupsPage } from "../HorseGroups/HorseGroupsPage";

export function VariablesTabs() {
  const isAdmin = useMemo(() => {
    return authService.isAdmin();
  }, []);
  return (
    <>
      <TabView>
        <TabPanel header="Umiejętności">
          <SkillLevels />
        </TabPanel>
        {isAdmin && (
          <TabPanel header="Rodzaje jazd">
            <RideTypesPage />
          </TabPanel>
        )}
        {isAdmin && (
          <TabPanel header="Rozmiary konia">
            <SizeTypesPage />
          </TabPanel>
        )}
        {isAdmin && (
          <TabPanel header="Grupy koni">
            <HorseGroupsPage />
          </TabPanel>
        )}
        {isAdmin && (
          <TabPanel header="Zabiegi">
            <TreatmentTypesPage />
          </TabPanel>
        )}
      </TabView>
    </>
  );
}
